/* tslint:disable */
/* eslint-disable */
export enum OpkraevningStateEnum {
  NotOpkraevet = 'NotOpkraevet',
  PartOpkraevet = 'PartOpkraevet',
  FullyOpkraevet = 'FullyOpkraevet'
}
